import { ShakaPlayerVersion } from './internal-config.enums';
export { OverrideableDevice, Proposition, ShakaEcmaScriptVersion, ShakaPlayerVersion, ShakaTimeoutPolicy } from './internal-config.enums';
/**
 * @internal
 */ /**
 * @internal
 */ // TODO this isn't device config. This is being passed down to the **player** in order to pass `castReceiverOptions`.
// This should be reworked and `castReceiverOptions` should be moved to `PlayersConfig`.
// For some reason, after upgrading the chromecast-caf-receiver types,
// adding mediaElement in the list above causes a RangeError: Maximum call stack size exceeded.
// When upgrading typescript-json-schema to a version which supports recursive types, the internal-config.schema.json
// goes from 1500 lines to something like 15k lines because of the HTMLMediaElement type.
/**
         * Optional media element to play content with. Default behavior is to use the first found media element in the page.
         */ // eslint-disable-line @typescript-eslint/no-explicit-any -- Casted as any due to issues mentioned above
// TODO Currently we are passing **device** config down to the **player** in order to pass `uhdSleMinimumAllowedFirmware`.
// This should be reworked and `uhdSleMinimumAllowedFirmware` should be moved to `AampPlayerConfig`.
/**
 * TODO delete this type and import `DevicesConfig` from client-lib-js-device
 * @internal
 */ export var SHAKA_PLAYER_VERSION_DEFAULT = ShakaPlayerVersion.V_3_3_10; /**
     * Some devices struggle with the transition from clear content to protected content
     * This configuration option performs a delayed seek to the current position
     * after this transition. Sometimes this kind of seek can help 'kick start'
     * the device back into a good state.
     */  /**
 * @public
 */  // can have performance impact if enabled
 /**
 * @public
 */  /**
 * @public
 */  // The maximum transition time between assets
 // Currently only used for SLE Preroll but may be used for general CSAI in the future
 /**
 * @public
 */  /**
 * @internal
 * Properties in the internal config that cannot change between sessions
 */  /**
 * @internal
 * Properties in the internal config that can change between sessions
 */  // Currently not in Remote Config likely to change in the future
 // Currently not in Remote Config likely to change in the future
 // Currently not in Remote Config likely to change in the future
 // Currently not in Remote Config likely to change in the future
 // Currently not in Remote Config likely to change in the future
 // Currently not in Remote Config likely to change in the future
 // Currently not in Remote Config likely to change in the future
 // Currently not in Remote Config likely to change in the future
 // Currently not in Remote Config likely to change in the future
 // Currently not in Remote Config likely to change in the future
 /**
 * @internal
 */  /**
 * @internal
 */ 

//# sourceMappingURL=internal-config.js.map